// Back and Forward restore a page from history with the props it had when it
// was stored (#524), and a prefetched page arrives with the props it had when
// it was fetched. The signed-in user's own state may have changed since: a new
// language, font size or plan. Rendering the older copy would undo those
// changes on screen, and the language and analytics listeners would act on it.
//
// Every page passes through the app's resolver before it renders (Inertia's
// resolve(name, page)), restored ones too. Each server response carries
// `servedAt`, the moment the request started, also on partial reloads, so
// freshenPage keeps the newest `currentUser` and gives it to any older page of
// the same user. Only `currentUser`: no page sends a prop of that name, while
// staff pages send their own `entitlements` lists under the shared prop's name.

let latest = null;

/**
 * Updates `page` in place before it renders. A newer page's currentUser
 * becomes the latest copy. An older page of the same user takes it; an older
 * page of anyone else is left alone, so nothing of one user's is written into
 * another's page.
 */
export function freshenPage(page) {
  const props = page?.props;
  const servedAt = props?.servedAt;
  if (typeof servedAt !== 'number') return;

  const user = props.currentUser;
  if (latest && servedAt < latest.servedAt) {
    if (user?.id && user.id === latest.user?.id) {
      props.currentUser = latest.user;
    }
    return;
  }
  latest = { servedAt, user };
}
